const DEFAULT_SWITCH_CLASS_NAME = 'filter-switch';

export default DEFAULT_SWITCH_CLASS_NAME;
